/* eslint-disabled */
import Step from "./Step";
import Platform from "./Platform";
import Tag from "./Tag";
import SurveyExtend from "@/entity/extends/SurveyExtend";
import Question from "@/entity/Question";
import Section from "@/entity/Section";
import Mapping from "@/entity/Mapping";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Survey extends SurveyExtend {
    public id!: number;
    public branch?: string = null;
    public label = "";
    public slug = "";
    public template? = "";
    public steps: Array<Step> = [];
    public active?: boolean;
    public aliases: any[] = [];
    description?: string;
    public item? = "";
    public ranking!: number;
    public platforms: Array<Platform> = [];
    public isRoot?: boolean;
    public uuid = "";
    public createdAt?: Date;
    public updatedAt?: Date;
    public createdFromIp? = "";
    public updatedFromIp? = "";
    public deletedAt?: Date;
    public tags: Array<Tag> = [];
    public mappings: Array<Mapping> = [];
    public isImport?: boolean;
    public allowOrder?: boolean;
    public type?: 'FORM' | 'COMPARISON' | null;
    public completionMessage?: string;
    

    constructor(object?: any) {
        super(object);
        if (object) {
            this.id = object.id;
            this.branch = object.branch;
            this.label = object.label;
            this.slug = object.slug;
            this.allowOrder = object.allowOrder;
            this.template = object.template;
            this.description = object.description;
            this.isImport = object.isImport;
            hydrateCollection(object.steps, Step, this.steps);
            this.active = object.active;

            this.aliases = object.aliases;
            this.item = object.item;
            this.ranking = object.ranking;

            this.type= object.type;
            this.completionMessage= object.completionMessage;
            hydrateCollection(object.platforms, Platform, this.platforms);
            this.isRoot = object.isRoot;
            this.uuid = object.uuid;
            if (object.createdAt) {
                this.createdAt = new Date(object.createdAt);
            }
            if (object.updatedAt) {
                this.updatedAt = new Date(object.updatedAt);
            }
            this.createdFromIp = object.createdFromIp;
            this.updatedFromIp = object.updatedFromIp;
            if (object.deletedAt) {
                this.deletedAt = new Date(object.deletedAt);
            }
            hydrateCollection(object.mappings, Mapping, this.mappings);
            hydrateCollection(object.tags, Tag, this.tags);
        }
    }
}
